import React, { useMemo } from 'react';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react';
import commandBarStyles from 'styles/commandBarStyles';
import CounterPerType from './CounterPerType';
import CounterPerStatusEnTotaal from './CounterPerStatusEnTotaal';
import DateRangeSelector from 'components/DateRangeSelector/DateRangeSelector';
import { useDateRangeFilter } from 'components/DateRangeSelector/useDateRangeFilter';

const Dashboard: React.FC<{}> = props => {
    const { dateRange, onDateRangeChanged } = useDateRangeFilter();    
    const commandBarItems: ICommandBarItemProps[] = useMemo(
        () => [
            {
                key: 'pagetitle',
                onRender: () => (
                    <div className="mutatielog-title page-title">Dashboard</div>
                )
            },
        ],
        []
    );

    const onRefresh = () => {
        //set date range to dateRange
        onDateRangeChanged({...dateRange});
    };
    const commandBarItemsFar: ICommandBarItemProps[] = useMemo(
        () => [
            {
                key: 'refresh',
                text: 'Vernieuwen',
                iconProps: { iconName: 'Refresh', className: 'icon' },
                split: false,
                ariaLabel: 'Vernieuwen',
                onClick: onRefresh,
            },
        ],
        [dateRange]
    );

    return (
        <div className="dashboard" style={dashboardStyles}>
            <CommandBar items={commandBarItems} farItems={commandBarItemsFar} styles={commandBarStyles}/>
            <div className="dashboard-daterange" style={dateRangeStyles}>
                <DateRangeSelector dateRange={dateRange} onDateRangeChange={onDateRangeChanged}></DateRangeSelector>
            </div>
            <div className="dashboard-content" style={contentStyles}>
                <CounterPerStatusEnTotaal/>
                <CounterPerType/>
            </div>
        </div>
  )
};
export default Dashboard

const dashboardStyles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
};

const contentStyles: React.CSSProperties = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
};

const dateRangeStyles: React.CSSProperties = { 
    paddingTop: '16px',
    paddingLeft: '25px',
};
